(() => {
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('[data-cart-drawer]');
  const copy = document.body?.dataset || {};
  const money = cents => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: window.Shopify?.currency?.active || 'JPY' }).format(cents / 100);

  const openDrawer = async () => {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    await refreshCart();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
  };
  const refreshCart = async () => {
    const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = money(cart.total_price));
    const target = document.querySelector('[data-cart-items]');
    if (!target) return;
    if (!cart.items.length) { target.innerHTML = `<p class="drawer-empty">${copy.cartEmpty || ''}</p>`; return; }
    target.innerHTML = cart.items.map(item => `<div class="drawer-item"><img src="${item.image || ''}" alt=""><div><a href="${item.url}"><strong>${item.product_title}</strong></a><p>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</p><small>${copy.cartQuantity || ''} ${item.quantity}</small></div><span>${money(item.final_line_price)}</span></div>`).join('');
  };

  document.addEventListener('click', e => {
    if (e.target.closest('[data-cart-open]')) openDrawer();
    if (e.target.closest('[data-cart-close]')) closeDrawer();
    const thumb = e.target.closest('[data-media-src]');
    if (thumb) { const main = document.querySelector('.product-media>img'); if (main) main.src = thumb.dataset.mediaSrc; }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-ajax-cart], [data-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error(copy.cartError || '');
      await openDrawer();
    } catch (err) { window.alert(err.message); }
    finally { if (button) button.disabled = false; }
  });
  const variantSelect = document.querySelector('[data-product-form] select[name="id"]');
  if (variantSelect) variantSelect.addEventListener('change', e => {
    const text = e.target.options[e.target.selectedIndex].textContent;
    const price = text.split('—').pop()?.trim().replace(copy.soldOutSuffix || '', '');
    const target = document.querySelector('[data-product-price]');
    if (target && price) target.textContent = price;
  });
})();
